import axios from 'axios';

import { setupInterceptors } from './interceptors';
import { BASE_URL } from '../const/ConstBase';

export const api = setupInterceptors(
    axios.create({
        baseURL: BASE_URL,
    })
);
